import { Modal } from '@infura/packages.ui/Modal'

import { CreateProjectKeyForm } from 'components/dashboard/projects-dashboard/CreateProjectKeyForm'

import { InfuraStats } from 'lib/stats/stats-types'

type CreateProjectModalProps = {
  isOpen: boolean
  onClose: () => void
  selectedProduct?: InfuraStats.ProductType
}

export function CreateProjectModal({ isOpen = false, onClose }: Readonly<CreateProjectModalProps>) {
  return (
    <Modal heading='Create a new API key' open={isOpen} setIsOpen={() => onClose()}>
      <CreateProjectKeyForm />
    </Modal>
  )
}
